export default __webpack_public_path__ + "images/ha_logo.png";